import { convetToTitleCase } from '@zeta-core';

export type clientPartnerJointTabsType = {
  label: string;
  value: string;
};

export const clientPartnerJointTabs = (isJoint = false, hasSummary = false): clientPartnerJointTabsType[] => {
  if (isJoint && hasSummary) {
    return [
      { label: 'Summary', value: 'summary' },
      { label: 'Client', value: 'client' },
      { label: 'Partner', value: 'partner' },
      { label: 'Joint', value: 'joint' },
    ];
  }

  if (isJoint) {
    return [
      { label: 'Client', value: 'client' },
      { label: 'Partner', value: 'partner' },
      { label: 'Joint', value: 'joint' },
    ];
  }

  return [
    { label: 'Client', value: 'client' },
    { label: 'Partner', value: 'partner' },
  ];
};

export const yesNoObject = [
  { label: 'Yes', value: 'YES' },
  { label: 'No', value: 'NO' },
];

export const yesNoObjectBoolean = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const interestedNotInterestedObject = [
  { label: 'Interested', value: 'INTERESTED' },
  { label: 'Not Interested', value: 'NOT_INTERESTED' },
];

export const CAPintObject = [
  { label: 'CAP', value: 'CAP' },
  { label: 'int', value: 'INT' },
];

export const getCAPIntObject = (x: string) => {
  if (x?.toLowerCase() === 'cap') {
    return { label: 'CAP', value: 'CAP' };
  }

  if (x?.toLowerCase() === 'int') {
    return { label: 'int', value: 'INT' };
  }

  return { label: '', value: '' };
};

export const monthlyAnnuallyObject = [
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Annually', value: 'Annually' },
];

export const weeklyMonthlyQuarterlyAnnuallyObject = [
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Annually', value: 'Annually' },
];

export const getYesNoObject = (x: string) => {
  if (x.toUpperCase() === 'YES') {
    return 'YES';
  }

  if (x.toUpperCase() === 'NO') {
    return 'NO';
  }

  return '';
};

export const getLabel = (tab: any, clientPartnerDetails: any) => {
  if ((tab.value === 'client' || tab.value === 'CLIENT') && clientPartnerDetails?.clientDetail?.name) {
    return `${convetToTitleCase(clientPartnerDetails?.clientDetail?.title)} ${clientPartnerDetails?.clientDetail?.name}`;
  }

  if ((tab.value === 'partner' || tab.value === 'PARTNER') && clientPartnerDetails?.partnerDetail?.name) {
    return `${convetToTitleCase(clientPartnerDetails?.partnerDetail?.title)} ${clientPartnerDetails?.partnerDetail?.name}`;
  }

  return tab.label;
};

export const getClientPartnerId = (tab: string, clientPartnerDetails: any) => {
  if ((tab === 'client' || tab === 'CLIENT') && clientPartnerDetails?.clientDetail?.id) {
    return clientPartnerDetails?.clientDetail?.id;
  }

  if ((tab === 'partner' || tab === 'PARTNER') && clientPartnerDetails?.partnerDetail?.id) {
    return clientPartnerDetails?.partnerDetail?.id;
  }

  return '';
};
